export function rotatePoint({ x, y }, degrees) {
  const radians = (degrees * Math.PI) / 180;
  return { x: x * Math.cos(radians) - y * Math.sin(radians), y: x * Math.sin(radians) + y * Math.cos(radians) };
}

// Dimensions are physical screen regions; rotating the map never moves the roster.
export function monitorLayout(
  {
    width,
    height,
    gameWidth,
    gameHeight,
    charactersWidth,
    charactersHeight,
    side,
    characters,
    rotation,
    game = true,
    zoom = 1
  },
  available
) {
  const vertical = ['left', 'right'].includes(side);
  const share = characters
    ? !game
      ? 1
      : Math.min(0.9, Math.max(0.05, (vertical ? charactersWidth / width : charactersHeight / height) || 0.2))
    : 0;
  const desktop = available.width >= 768;
  const scale =
    Math.max(
      0.001,
      Math.min(
        (desktop ? Math.min(available.width - 48, available.width * 0.6) : available.width - 48) / width,
        (desktop ? Math.min(available.height - 110, available.height * 0.6) : available.height - 110) / height
      )
    ) * zoom;
  const screen = { width: width * scale, height: height * scale };
  const x = (available.width - screen.width) / 2;
  const y = Math.max(48, (available.height - screen.height - 26) / 2);
  const rosterWidth = vertical ? screen.width * share : screen.width;
  const rosterHeight = vertical ? screen.height : screen.height * share;
  const map = {
    x: x + (side === 'left' ? rosterWidth : 0),
    y: y + (side === 'top' ? rosterHeight : 0),
    width: Math.max(1, screen.width - (vertical ? rosterWidth : 0)),
    height: Math.max(1, screen.height - (vertical ? 0 : rosterHeight))
  };
  if (!characters) Object.assign(map, { x, y, ...screen });
  const degrees = Math.max(0, ['zero', 'ninety', 'one_eighty', 'two_seventy'].indexOf(rotation)) * 90;
  return {
    x,
    y,
    ...screen,
    map,
    degrees,
    side,
    game,
    roster: {
      x: side === 'right' ? x + screen.width - rosterWidth : x,
      y: side === 'bottom' ? y + screen.height - rosterHeight : y,
      width: rosterWidth,
      height: rosterHeight
    },
    base: degrees % 180 ? map.width / gameWidth : map.height / gameHeight,
    center: { x: map.x + map.width / 2, y: map.y + map.height / 2 }
  };
}
